window.$ = window.jQuery = require("jquery");

window.Swal = require("sweetalert2");

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

window.gsap = gsap;
window.ScrollToPlugin = ScrollToPlugin;

require("./dialogs/confirm_dialog");
require("./chat/chat-input");
require("./chat/external-api-stream");   // 使用外部串流 API
require("./chat/elevenlabs-streaming");
require("./chat/stop-chat-playback");
require("./chat/microsoft-speech-recognition");

$(function () {
    $("#rd-input-text").on("paste", function (event) {
        event.preventDefault();

        let text = (
            event.originalEvent.clipboardData || window.clipboardData
        ).getData("text");

        let selection = window.getSelection();
        if (!selection.rangeCount) return;
        selection.deleteFromDocument();

        let range = selection.getRangeAt(0);
        range.insertNode(document.createTextNode(text));

        range.setStartAfter(range.endContainer);
        selection.removeAllRanges();
        selection.addRange(range);
    });

    $("#rd-input-text").on("keydown", function (event) {
        if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
            event.preventDefault();
            sendButtonEvent();
        }
    });

    $("#rd-send-button").on("click", function (event) {
        sendButtonEvent();
    });

    // 選擇卡片
    $(".rd-click-card").on("click", function () {
        window.showPadSuggestionPart();

        stopRecognition();

        $(".right-part").addClass("do");

        let chatId    = $('meta[name="chat-id"]').attr("content");
        let question  = $(this).data("message");
        let agent_id  = $('meta[name="chat-user-id"]').attr("content");

        $.ajax({
            type: "POST",
            url: $('meta[name="get-card"]').attr("content"),
            data: {
                id: $(this).data("id"),
                chat_id: chatId,
                agent_id: agent_id,
            },
            dataType: "json",
            cache: false,
            success: function (data, textStatus, xhr) {
                setQuestionContent(question);

                window.textToSpeech(stripHTML(data.reply)).then(function (shouldPlay) {
                    setAnswerContent(data.reply, data.history_id);
                    if (shouldPlay) {
                        const audioElement = document.getElementById("audioPlayer");
                        audioElement.play().catch(function (e) { console.error("Play error", e); });
                    }
                }).catch(function (err) {
                    console.error(err);
                });
            },
        });
    });

    $("#rd-new-chat").on("click", function () {
        $.ajax({
            type: "POST",
            url: $('meta[name="new-chat"]').attr("content"),
            dataType: "json",
            cache: false,
            success: function (data, textStatus, xhr) {
                $('meta[name="chat-id"]').attr("content", data.chat_id);
                $("#rd-hello").show();
                $("#rd-card").show();
                $("#msgHistory").html("");
            },
        });
    });

    $(document).on("click", ".rd-return-button, #rd-return", function () {
        window.location.href = $(this).data("url");
    });
});

window.disableButton = function () {
    const chatTool = $(".chat-tool");
    chatTool.addClass("disable");
    chatTool.find(".voice-btn").prop("disabled", true);
    chatTool.find(".send-btn").prop("disabled", false);
    chatTool.find(".play-btn, .stop-btn").prop("disabled", false);
    $("#rd-disable-txt").show();
};

window.enableButton = function () {
    const chatTool = $(".chat-tool");
    chatTool.removeClass("disable");
    chatTool.find("button").prop("disabled", false);
    $("#rd-stop-streaming").hide();
    $("#rd-disable-txt").hide();
};

window.showLoading = function () {
    $("#rd-loading").show();
};

window.hideLoading = function () {
    $("#rd-loading").hide();
};

function sendButtonEvent() {
    if (!window.hasChatInputMessage()) {
        return;
    }

    window.showPadSuggestionPart();

    let message   = window.getChatInputMessage();
    let requestId = null;

    if (typeof window.stopAllChatActions === "function") {
        window.stopAllChatActions();
    }

    if (typeof window.startChatRequest === "function") {
        requestId = window.startChatRequest();
    }

    stopRecognition();
    disableButton();

    $(".right-part").addClass("do");

    askOpenAI(message, true, function (reply, callback) {
        if (
            requestId !== null &&
            typeof window.isCurrentChatRequest === "function" &&
            !window.isCurrentChatRequest(requestId)
        ) {
            return;
        }

        window.textToSpeech(reply).then(function (shouldPlay) {
            if (
                requestId !== null &&
                typeof window.isCurrentChatRequest === "function" &&
                !window.isCurrentChatRequest(requestId)
            ) {
                return;
            }

            if (shouldPlay) {
                const audioElement = document.getElementById("audioPlayer");
                audioElement.play().catch(function (e) { console.error("Play error", e); });
            }
            if (typeof callback === "function") callback();
        }).catch(function (err) {
            console.error(err);
        });
    }, requestId);
}

function stripHTML(input) {
    let parser = new DOMParser();
    let doc    = parser.parseFromString(input, "text/html");
    return doc.body.textContent || "";
}

